export enum HoldersPosition {
  AtFeet = 'AtFeet',
  AtHead = 'AtHead',
  Behind = 'Behind',
  OnTop = 'OnTop',
  Spooning = 'Spooning',
  NotApplicable = 'NotApplicable',
}
